import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { CTAButton } from './CTAButton';
export function TraiesteAbout() {
  return <section className="py-20 lg:py-32 bg-brand-cream relative overflow-hidden" data-id="element-1981">
      <div className="max-w-7xl mx-auto px-6" data-id="element-1982">
        {/* Mobile-only centered title (shown above the photo on mobile) */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8
      }} className="lg:hidden mb-10 text-center" data-id="element-1983">
          <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={true} data-id="element-1984" />
        </motion.div>

        <div className="grid lg:grid-cols-[2fr_3fr] gap-12 lg:gap-20 items-stretch" data-id="element-1985">
          {/* Image */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative w-full max-w-[400px] mx-auto lg:mx-0 lg:max-w-none aspect-[3/4] lg:aspect-auto lg:min-h-full" data-id="element-1986">
            <div className="hidden lg:block absolute -top-6 -left-6 w-24 h-24 border-[1.5px] border-brand-gold/30 rounded-full pointer-events-none" data-id="element-1987" />
            <div className="hidden lg:block absolute -bottom-6 -right-6 w-32 h-32 border border-brand-gold/25 rounded-full pointer-events-none" data-id="element-1988" />
            <div className="hidden lg:block absolute -top-3 -right-3 w-2.5 h-2.5 bg-brand-gold/70 rotate-45 pointer-events-none" data-id="element-1989" />

            <div className="absolute inset-0 rounded-[32px] overflow-hidden shadow-warm" data-id="element-1990">
              <img src="https://cdn.magicpatterns.com/uploads/hbWtuJ6aCvHUuJajw2QL9A/Screenshot_2026-05-15_at_21.29.02.png" alt="Adrian Huniade" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-1991" />
            </div>
          </motion.div>

          {/* Content */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} data-id="element-1992">
            {/* Desktop-only heading inside text column */}
            <div className="hidden lg:block" data-id="element-1993">
              <SectionHeading title="Cine sunt eu și de ce am creat acest curs" centered={false} data-id="element-1994" />
            </div>

            <div className="space-y-6 text-lg text-brand-text/80 leading-relaxed mb-10" data-id="element-1995">
              <p data-id="element-1996">
                Sunt <strong data-id="element-1997">Adrian Huniade</strong>, Instructor Internațional
                Theta Healing® și Facilitator Heal Your Life, cu peste 25 de
                ani de experiență în terapii complementare și dezvoltare
                personală.
              </p>
              <p data-id="element-1998">
                Am creat cursul Trăiește în Prezent și Împlinește-ți Visul
                pentru că am văzut mulți oameni care aveau totul pe hârtie, dar
                nu se simțeau împliniți. Aveau job, familie, bani, dar lipsea
                ceva esențial: sensul, prezența, bucuria de a trăi cu adevărat.
                Și am înțeles că problema nu era că le lipsea ceva în exterior.
                Le lipsea conexiunea cu ei înșiși.
              </p>
              <p data-id="element-1999">
                Acest curs aduce laolaltă cele 7 legi spirituale ale succesului,
                exerciții practice pentru sănătate și echilibru, practici de
                recunoștință și iubire și un proces clar prin care înveți să
                trăiești conștient, nu pe pilot automat.
              </p>

              <p className="text-xl md:text-2xl font-subtitle text-brand-purple font-medium py-4" data-id="element-2000">
                Am testat aceste principii pe propria viață și cu sute de
                cursanți. Rezultatul e mereu același: când înveți să fii prezent
                și să te aliniezi cu ceea ce contează cu adevărat, viața se
                transformă.
              </p>

              <div className="p-6 bg-brand-purple/5 border-l-4 border-brand-purple rounded-r-xl" data-id="element-2001">
                <p className="font-subtitle italic text-xl text-brand-text" data-id="element-2002">
                  "Predau simplu, clar și structurat, cu multă iubire. Iar
                  cursanții mei spun că simt această iubire și că schimbarea
                  vine natural."
                </p>
              </div>
            </div>

            <CTAButton className="items-start" data-id="element-2003" />
          </motion.div>
        </div>
      </div>
    </section>;
}